export const api = {
  operationConf: {
    list: '/recom/operation/list',
    getPageListByPlatfromId: '/recom/page/listByPlatformId',
    getOperationListByPageId: '/recom/operation/listByPageId',
    detail: '/recom/operation/detail',
  },
  operation: {
    list: '/recom/material/list',
    treeList: '/recom/material/treeList',
    addInit: '/recom/material/addInit',
    add: '/recom/material/add',
    save: '/recom/material/save',
    modInit: '/recom/material/modInit',
    mod: '/recom/material/mod',
    online: '/recom/material/online',
    offline: '/recom/material/offline',
    orderList: '/recom/material/orderList',
    moveUp: '/recom/material/moveUp',
    moveDown: '/recom/material/moveDown',
    checkLink: '/recom/material/skipCheck',
  }
}